import React, {
  useEffect, useState, useRef, useContext,
} from 'react';
import {
  Box,
  BottomNavigation, BottomNavigationAction, Paper, Grid,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
// import Images from '../../../Configs/images';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ROUTES from '../../../Configs/routes';
import { getToken, getUserData } from '../../../Utils/storages';
import MenuIconHome from '../../../Assets/MenuIconHome';
import Colors from '../../../Configs/colors';
import MenuIconStorage from '../../../Assets/MenuIconStorage';
import MenuIconMarket from '../../../Assets/MenuIconMarket';
import MenuIconNotif from '../../../Assets/MenuIconNotif';
import { getUserData as getUser } from '../../../Redux/Models/user';
import InitializationContext from '../../../Context/InitializationContext';

export default function FixedBottomNavigation({ children, classes, noNav }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [value, setValue] = useState(-1);
  const { t } = useTranslation();
  // const [loading, setLoading] = useState(true);
  const { firstInit, finishInitialization } = useContext(InitializationContext);

  const token = getToken();
  const userData = getUserData();

  const updateUser = async () => {
    // setLoading(true);
    await dispatch(getUser(userData.id));
    // setLoading(false);
    finishInitialization();
  };

  useEffect(() => {
    if (token && userData.id && firstInit) {
      updateUser();
    } else {
      // setLoading(false);
    }
  }, []);

  // useEffect(() => {
  //   if (token
  //     && userData
  //     && !userData.subscription
  //     && !location.pathname.match(/subscription/g)
  //     && !location.pathname.match(/market/g)
  //     && !loading) {
  //     navigate(ROUTES.subscription());
  //   }
  // }, [token, userData, loading]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    switch (location.pathname?.split('/')[1]) {
      case '':
      case 'home': setValue(0);
        break;
      case 'my-storages': setValue(1);
        break;
      case 'market': setValue(2);
        break;
      case 'notifications': setValue(3);
        break;
      default: setValue(0);
    }
  }, [location.pathname]);

  const ref = useRef(null);
  const [parentWidth, setParentWidth] = useState(500);

  useEffect(() => {
    setParentWidth(ref.current ? ref.current.offsetWidth : 0);
    window.addEventListener('resize', () => {
      setParentWidth(ref.current ? ref.current.offsetWidth : 0);
    });
  }, [ref.current]);

  return (
    <Grid container justifyContent="center" sx={{ bgcolor: '#F7F7F7' }}>
      <Grid item xs={12} sm={8} md={6} lg={5}>
        <Box sx={{ pb: noNav ? 0 : 10, background: 'white' }} ref={ref} className={classes.root}>
          <main className={classes.white}>
            {children}
          </main>
          {!noNav
          && (
          <Paper className="nav-container">
            <BottomNavigation
              showLabels
              sx={{ width: parentWidth }}
              className="navigation"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              <BottomNavigationAction onClick={() => navigate(ROUTES.home())} label={t('menu.home')} icon={<MenuIconHome sx={{ color: 'transparent' }} iconcolor={value === 0 ? Colors.jura : Colors.neutral} />} />
              <BottomNavigationAction onClick={() => navigate(ROUTES.myStorages())} label={t('menu.myStorage')} icon={<MenuIconStorage sx={{ color: 'transparent' }} iconcolor={value === 1 ? Colors.jura : Colors.neutral} />} />
              <BottomNavigationAction onClick={() => navigate(ROUTES.market())} label={t('menu.oenoMarket')} icon={<MenuIconMarket sx={{ color: 'transparent' }} iconcolor={value === 2 ? Colors.jura : Colors.neutral} />} />
              <BottomNavigationAction onClick={() => navigate(ROUTES.notifications())} label={t('menu.notif')} icon={<MenuIconNotif sx={{ color: 'transparent' }} iconcolor={value === 3 ? Colors.jura : Colors.neutral} />} />
            </BottomNavigation>
          </Paper>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
